async function getImageMetadata(
  file: File,
  ImageClass = Image,
): Promise<{
  name: string;
  width: number;
  height: number;
  size: number;
  type: string;
  lastModified: number;
  base64: string;
}> {
  return new Promise((res) => {
    const reader = new FileReader();

    reader.onload = function onFileLoaded() {
      const img = new ImageClass();

      img.onload = function onImageLoaded() {
        res({
          name: file.name,
          width: img.width,
          height: img.height,
          size: file.size,
          type: file.type,
          lastModified: file.lastModified,
          base64: reader.result as string,
        });
      };

      img.src = reader.result as string;
    };

    reader.readAsDataURL(file);
  });
}

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

function getImageTypeFromBase64(base64?: string) {
  if (base64) {
    const [fileType] = base64.split(';');

    return fileType.split('/')?.[1];
  }

  return '';
}

export { getImageMetadata, getBase64, getImageTypeFromBase64 };
